import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";

import LandingPage from "./pages/LandingPage";
import "./index.css";

const FullAppRoot = lazy(() => import("./FullAppRoot"));
const isLandingRoute = window.location.pathname === "/";

if (!isLandingRoute) {
  document.documentElement.classList.add("dark");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Suspense fallback={null}>
    {isLandingRoute ? <LandingPage /> : <FullAppRoot />}
  </Suspense>
);
